// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__K7PTz","col":"ProductsDashboard_col__sIac2","card":"ProductsDashboard_card__d0AM+"};